import React, { Component } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { endpoint } from '../../helpers/constantes';
import { connect } from 'react-redux';
import  Navigation from '../Navigation/Navigation'
import { modificaLoader } from '../../actions/LoaderActions';

class CadastroOlt extends Component {

  
    constructor(props) {
        super(props);
        const nvl = localStorage.getItem('nvl');

        if (nvl < 3) {
            this.props.history.goBack();
        }
    }
  
    state = {
    nome: '',
    cpf: '',
    dtNascimento: '',
    alert: {
      show: false,      
      title: 'Aviso',
      message: '',
      type: {
        warning: false,
        success: false,
        danger: false,
      }
    }
  }


  limpar = () => {
    document.getElementById("cad-usuario").reset();
    this.setState({
      nome: '',
      ip: '',
    })
  }

  cadastrar = (e) => {
    this.props.modificaLoader(true);
    e.preventDefault();
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${this.props.token}`)
    fetch(`${endpoint}/user`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({nome: this.state.nome, 
      user: this.state.cpf,
      password: this.state.dtNascimento,
      nivel_acesso: 1})})
    .then(result => {
      if (result.ok) {
        this.props.modificaLoader(false);
        this.limpar();
        this.setState({
          alert: {
            show: true,             
            title: 'Sucesso',
            message: result.statusText,
            type: {
              warning: false,
              success: true,
              danger: false,
            }
          }
        })
      }else{
        this.props.modificaLoader(false);
        this.setState({
          alert: {
            show: true,
            title: 'Falha',
            message: result.statusText,
            type: {
              warning: true,
              success: false,
              danger: false,
            }
          }
        })
      }
    })    
    .catch(err => {
      this.props.modificaLoader(false);
      this.setState({
        alert: {
          show: true,
          title: 'Erro! Estamos sem conectividade ?',
          message: err.message,
          type: {
            warning: false,
            success: false,
            danger: true,
          }
        }
      })
    })
  };

  render() {
    return (
      <Navigation history={this.props.history}>
        <h1>Cadastre um novo usuário</h1>
        <p style={{fontSize: '12px', color: '#aeaeae'}}>Confira os dados antes de confirmar</p>            
        <form id="cad-usuario" onSubmit={this.cadastrar}>
          <div className="form-group">
            Nome:
            <input
            ref={(input) => { this.nome = input; }} 
            className="form-control" 
            type="text" 
            name="nome" 
            value={this.props.nome} 
            onChange={event => this.setState({nome: event.target.value})} 
            required
            autoFocus/>
          </div>
          <div className="form-group">
            CPF:
            <input 
            className="form-control" 
            mask="999.999.999-99"
            type="text" 
            name="cpf" 
            value={this.state.cpf} 
            // onChange={event => this.setState({cpf: event.target.value.replace(/\D/,'')})} 
            onChange={event => {
              this.setState({cpf: event.target.value.replace(/\D/gi, '')})
            }
          }
            required/>
          </div>
          <div className="form-group">
            Data de nascimento:
            <input 
            className="form-control" 
            type="text" 
            name="dtNascimento" 
            value={this.state.dtNascimento} 
            // onChange={event => this.setState({dtNascimento: event.target.value.replace(/\D/,'')})}
            onChange={event => {
                this.setState({dtNascimento: event.target.value.replace(/\D/gi,'')})
              }
            }
            required/>
          </div>
          <div className="form-group">
            <button 
            className="btn btn-outline-danger" 
            type="submit" 
            name="Cadastrar">
            Cadastrar
            </button>
            <button 
            className="btn btn-outline-secondary ml-3" 
            type="button" 
            onClick={this.limpar} 
            name="Limpar">
            Limpar
            </button>
          </div>
        </form>
        <SweetAlert {...this.state.alert.type}
          title={this.state.alert.title}
          show={this.state.alert.show}
          onConfirm={() => {
            this.setState({ ...this.state, alert: {show: false, title: ''}})
            this.nome.focus();
          }}>
          {this.state.alert.message}
        </SweetAlert>
      </Navigation>
    );
  }
}
const mapStateToProps = state => ({
  token: state.LoginReducer.token,
});

export default connect(mapStateToProps, { modificaLoader })(CadastroOlt);


// WEBPACK FOOTER //
// ./src/components/Usuarios/Cadastro.js